import client from 'services/client'
import { toCamel } from 'change-object-case'

const BASE_PATH = '/v2/agentic'

/**
 * Fetches agentic metadata from the backend: prompt workflows and app domains (used by the
 * workflow/app-domain pickers) plus selector and context types (used to validate prompt bodies).
 * @returns {Promise<{workflows: Array<object>, appDomains: Array<object>, selectorTypes: Array<object>, contextTypes: Array<object>}>}
 *   camelCased metadata, or an empty object when the response has no body
 */
async function getAgenticMetadata() {
  const response = await client().get(`${BASE_PATH}/metadata`)

  return toCamel(response?.data || {}, { arrayRecursive: true })
}

export { getAgenticMetadata }
